exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".y-chat-message.is_me a{color:#fff;text-decoration:underline}.y-chat-message.is_me{color:#fff}", ""]);

// exports
